export const UPDATE_STEPLIST = 'survey/UPDATE_STEPLIST'

export const updateSteplist = pages => ({
  type: UPDATE_STEPLIST,
  payload: pages,
})
